import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './enrichment-ip-diversity.module.sass';
import { Button, Typography, Tooltip, Select, Table, Popover } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import { InfoCircleFilled, MoreOutlined } from '@ant-design/icons';

function EnrichmentIpDiversity({
  history,
  newData,
  statusNew,
  parsedData,
  props,
}) {
  const { Title, Text, Paragraph } = Typography;
  const data = newData?.response;
  const [timelineSpan, setTimelineSpan] = useState('30');

  const diversitySelectChange = (value) => {
    setTimelineSpan(value);
  };

  function handleLookup(name) {
    history.push(
      `/explore-result?name=${
        name ?? parsedData?.result
      }&queryType=query&type=any&backLink=` +
        encodeURIComponent(window.location.pathname) +
        encodeURIComponent(window.location.search) +
        '&origin_uid=Explore',
    );
  }

  function diversitySelect() {
    return (
      <>
        <label>Select another period</label>
        <Select
          className={styles.diversity_select}
          defaultValue={timelineSpan}
          onChange={diversitySelectChange}
          options={[
            {
              value: '30',
              label: '30 days',
            },
            {
              value: '60',
              label: '60 days',
            },
            {
              value: '90',
              label: '90 days',
            },
          ]}
        />
        {props?.mySubscriptionPlan?.has_access_to_explore ? (
          <Link
            to={
              `explore-result?name=${
                data?.ip_diversity?.host ?? parsedData?.result
              }&queryType=ipdiversity&type=A&backLink=` +
              encodeURIComponent(window.location.pathname) +
              encodeURIComponent(window.location.search) +
              `&window=${timelineSpan}` +
              '&origin_uid=Explore'
            }
          >
            <Button className={styles.diversity_button} type="primary">
              Show Timeline
            </Button>
          </Link>
        ) : (
          <Tooltip
            title={
              props?.mySubscriptionPlan?.has_access_to_explore ? (
                ''
              ) : (
                <>
                  This option is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Button
              disabled={!props?.mySubscriptionPlan?.has_access_to_explore}
              className={styles.diversity_button}
              type="primary"
            >
              Show Timeline
            </Button>
          </Tooltip>
        )}
      </>
    );
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Threat Name" />,
      dataIndex: 'name',
      key: 'name',
      render: (value, params) => {
        if (params?.tooltip) {
          return (
            <>
              {value + ' '}
              <Tooltip placement="top" title={params?.tooltip}>
                <InfoCircleFilled />
              </Tooltip>
            </>
          );
        } else {
          return value;
        }
      },
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
    },
    {
      dataIndex: 'addition',
      key: 'addition',
      className: styles.addition,
    },
  ];

  function returnTableData({ loading }) {
    return [
      {
        key: 1,
        name: 'Host',
        tooltip: (
          <Paragraph className="m-0">
            The host name represents the network or system used to deliver a
            user to a certain address or location
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {data?.ip_diversity?.host ? data?.ip_diversity?.host : '-'}
          </Text>
        ),
        addition: loading ? (
          <LoadingSkeleton />
        ) : props?.mySubscriptionPlan?.has_access_to_explore ? (
          <Link
            to={
              `/explore-result?name=${
                data?.ip_diversity?.host ?? parsedData?.result
              }&queryType=query&type=any&backLink=` +
              encodeURIComponent(window.location.pathname) +
              encodeURIComponent(window.location.search) +
              '&origin_uid=Explore'
            }
          >
            <Button
              type="primary"
              //onClick={() => handleLookup(data?.ip_diversity?.host)}
            >
              Lookup PADNS
            </Button>
          </Link>
        ) : (
          <Tooltip
            title={
              props?.mySubscriptionPlan?.has_access_to_explore ? (
                ''
              ) : (
                <>
                  This option is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Button
              disabled
              type="primary"
              // onClick={() => handleLookup(data?.ip_diversity?.host)}
            >
              Lookup PADNS
            </Button>
          </Tooltip>
        ),
      },
      {
        key: 2,
        name: 'ASN Diversity',
        tooltip: (
          <Paragraph className="m-0">
            How frequent an IP changes between AS numbers
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {data?.ip_diversity?.asn_diversity
              ? data?.ip_diversity?.asn_diversity
              : '-'}
          </Text>
        ),
        addition: null,
      },
      {
        key: 3,
        name: data?.ip_diversity?.asns?.length > 1 ? 'ASNs' : 'ASN',
        tooltip: (
          <Paragraph className="m-0">
            The IANA-allocated number of the AS
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {data?.ip_diversity?.asns?.length > 0 ? (
              data?.ip_diversity?.asns?.length > 2 ? (
                <Popover
                  placement="right"
                  content={data?.ip_diversity?.asns?.map(
                    (item, index) =>
                      index > 2 &&
                      (props?.mySubscriptionPlan?.has_access_to_explore ? (
                        <>
                          <Link
                            to={
                              `explore-result?name=${
                                data?.ip_diversity?.host ?? parsedData?.result
                              }&queryType=asn&type=asn&originalQueryURL=%2Fpadns%2Flookup%2Fdomain%2Fasns%2F${
                                data?.ip_diversity?.host ?? parsedData?.result
                              }%3Fresult_format%3Drecords%26asnum%3D${item}%26sort%3Dquery%252Fasc%26sort%3Danswer%252Fasc%26sort%3Dlast_seen%252Fdesc%26limit%3D100%26query_type%3DPADNS%2BASNs%2Bseen%2Bfor%2Bdomain%26origin_uid%3D2da02a84-1e01-4e19-b1e5-e615ab19f73b&backLink=` +
                              encodeURIComponent(window.location.pathname) +
                              encodeURIComponent(window.location.search)
                            }
                          >
                            {item}
                          </Link>
                          {index < data?.ip_diversity?.asns?.length - 1
                            ? ', '
                            : ''}
                        </>
                      ) : (
                        (index < data?.ip_diversity?.asns?.length - 1
                          ? ', '
                          : '') + item
                      )),
                    // (index === ['11','22','33','44','55']?.length - 1
                    // ? ''
                    // : ',') + item,
                  )}
                >
                  {data?.ip_diversity?.asns?.map(
                    (item, index) =>
                      index <= 2 &&
                      // (index ? ', ' : '') +
                      //  item,
                      (props?.mySubscriptionPlan?.has_access_to_explore ? (
                        <>
                          <Link
                            to={
                              `explore-result?name=${
                                data?.ip_diversity?.host ?? parsedData?.result
                              }&queryType=asn&type=asn&originalQueryURL=%2Fpadns%2Flookup%2Fdomain%2Fasns%2F${
                                data?.ip_diversity?.host ?? parsedData?.result
                              }%3Fresult_format%3Drecords%26asnum%3D${item}%26sort%3Dquery%252Fasc%26sort%3Danswer%252Fasc%26sort%3Dlast_seen%252Fdesc%26limit%3D100%26query_type%3DPADNS%2BASNs%2Bseen%2Bfor%2Bdomain%26origin_uid%3D2da02a84-1e01-4e19-b1e5-e615ab19f73b&backLink=` +
                              encodeURIComponent(window.location.pathname) +
                              encodeURIComponent(window.location.search)
                            }
                          >
                            {item}
                          </Link>
                          {index >= 0 && index <= 2 ? ', ' : ''}
                        </>
                      ) : (
                        (index >= 0 && index <= 2 ? ', ' : '') + item
                      )),
                  )}{' '}
                  <MoreOutlined style={{ transform: 'rotate(90deg)' }} />
                </Popover>
              ) : (
                data?.ip_diversity?.asns?.map((item, index) =>
                  // (index ? ', ' : '') +
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    <>
                      <Link
                        to={
                          `explore-result?name=${
                            data?.ip_diversity?.host ?? parsedData?.result
                          }&queryType=asn&type=asn&originalQueryURL=%2Fpadns%2Flookup%2Fdomain%2Fasns%2F${
                            data?.ip_diversity?.host ?? parsedData?.result
                          }%3Fresult_format%3Drecords%26asnum%3D${item}%26sort%3Dquery%252Fasc%26sort%3Danswer%252Fasc%26sort%3Dlast_seen%252Fdesc%26limit%3D100%26query_type%3DPADNS%2BASNs%2Bseen%2Bfor%2Bdomain%26origin_uid%3D2da02a84-1e01-4e19-b1e5-e615ab19f73b&backLink=` +
                          encodeURIComponent(window.location.pathname) +
                          encodeURIComponent(window.location.search)
                        }
                      >
                        {item}
                      </Link>{' '}
                      {index ? ', ' : ''}
                    </>
                  ) : (
                    (index ? ', ' : '') + item
                  ),
                )
              )
            ) : (
              '-'
            )}
          </Text>
        ),
        addition: null,
      },
      {
        key: 4,
        name: 'IP Diversity All',
        tooltip: (
          <Paragraph className="m-0">
            The amount of IPs pointed to over the last 30 days
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {data?.ip_diversity?.ip_diversity_all
              ? data?.ip_diversity?.ip_diversity_all
              : '-'}
          </Text>
        ),
        addition: loading ? <LoadingSkeleton /> : diversitySelect(),
      },
      {
        key: 5,
        name: 'IP Diversity Groups',
        tooltip: (
          <Paragraph className="m-0">
            The number of different groups of IPs pointed to over the last 30
            days, where a group may concist of one or more IPs pointed to at the
            same time
          </Paragraph>
        ),
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {data?.ip_diversity?.ip_diversity_groups
              ? data?.ip_diversity?.ip_diversity_groups
              : '-'}
          </Text>
        ),
        addition: null,
      },
    ];
  }

  return (
    <div id="enrichmentIpDiversity" className={styles.enrichment_ip_diversity}>
      <div className={styles.title}>
        <Title level={4}>IP Diversity</Title>
        <Text>
          The amount of IPs pointed to over the last 30 days.{' '}
          <Text strong>Silent Push invention</Text>
        </Text>
      </div>
      <Table
        columns={columns}
        dataSource={returnTableData({ loading: statusNew === 'loading' })}
        pagination={false}
      />
    </div>
  );
}

export default EnrichmentIpDiversity;
